const React = require("react");

class Label extends React.Component {

    constructor(props){
        super(props);
    }

    get for(){
        return this.props.forHtml;
    }

    render(){

        if(this.props.children === null){
            return null;
        }

        return (
            <label htmlFor={this.for} title={this.props.title}>
                {this.props.children}
            </label>
        );
    }

}

module.exports = Label;
